export default {
  inserted(el, binding) { 
    // Forces the value to be lowercase and replaces spaces and underscores with hyphens to abide by test id conventions
    const normalized = String(binding.value).toLowerCase().replaceAll('_', '-').replaceAll(' ', '-');
    el.setAttribute('data-testid', normalized);
  }
};
